import * as types from './constants';

// Token Auth
export const tokenAuthRequest = data => (
  { type: types.TOKEN_AUTH_REQUEST, payload: data }
);

export const tokenAuthDone = data => (
  { type: types.TOKEN_AUTH_DONE, payload: data }
);

export const tokenAuthFailed = errors => (
  { type: types.TOKEN_AUTH_FAILED, payload: errors }
);